/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type OAuthProvider =
  | 'GOOGLE'
  | 'MICROSOFT';

export type CalendarFormStaffsQueryVariables = Exact<{ [key: string]: never; }>;


export type CalendarFormStaffsQuery = { staffsByPlanner: Array<{ guid: string, displayName: string, connectedThirdPartyProvider: Types.OAuthProvider | null }> };


export const CalendarFormStaffsDocument = gql`
    query CalendarFormStaffs {
  staffsByPlanner {
    guid
    displayName
    connectedThirdPartyProvider
  }
}
    `;

/**
 * __useCalendarFormStaffsQuery__
 *
 * To run a query within a Vue component, call `useCalendarFormStaffsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarFormStaffsQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useCalendarFormStaffsQuery();
 */
export function useCalendarFormStaffsQuery(options: VueApolloComposable.UseQueryOptions<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables>(CalendarFormStaffsDocument, {}, options);
}
export function useCalendarFormStaffsLazyQuery(options: VueApolloComposable.UseQueryOptions<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables>(CalendarFormStaffsDocument, {}, options);
}
export type CalendarFormStaffsQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<CalendarFormStaffsQuery, CalendarFormStaffsQueryVariables>;